<template>
  <main class="object-story">
    <div class="container">
      <object-story-single/>
    </div>
  </main>
</template>

















<script>
import ObjectStorySingle from '../components/ObjectStorySingle.vue'

export default {
  name: 'ObjectStory',
  components: {
    ObjectStorySingle,
  }
}
</script>
